import axios from "axios";
import authHeader from "./auth/auth-header";

const baseUrl = process.env.REACT_APP_API_URL;
 /**
   * Obtener el listado de imágenes o videos
   * @param {string} isImage - indica a que archivo del servidor apuntar true=imagenes false=videos
   * @author Kenzo Sashida 
   * @version 1.0.0 - Julio 2024
   */
const getImages = async(isImage) =>{
    const url = `${baseUrl}/slider/multimedia?slider=${isImage}`
    const token = await authHeader()

    const response = await axios.get(url,{
        headers:token
    })
    return response.data
}
 /**
   * Subir una imágen al servidor
   * @param {string} isImage - indica a que archivo del servidor apuntar true=imagenes false=videos
   * @param {string} data - imágen o video
   * @author Kenzo Sashida 
   * @version 1.0.0 - Julio 2024
   */
const uploadImage = async(data, isImage) =>{
    const formData = new FormData()
    formData.append('file', data)
    const url = `${baseUrl}/slider/upload-multimedia/${isImage}`
    const token = await authHeader()

    const response = await axios.post(url,formData,{
        headers:token,
        onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            document.getElementById('upload-progress').value = percentCompleted;
          }
    })
    return response.data
}
 /**
   * Actualizar imágen o video
   * @param {string} isImage - indica a que archivo del servidor apuntar true=imagenes false=videos
   * @param {string} name - nombre de imágen o video
   * @author Kenzo Sashida 
   * @version 1.0.0 - Julio 2024
   */
const updateImage = async(name,isImage) =>{
    const url = `${baseUrl}/slider/modify-name/${name.oldName}/${name.newName}?slider=${isImage}`
    const token = await authHeader()

    const response = await axios.put(url,{},{
        headers:token
    })
    return response.data
}
 /**
   * Borrrar imágen o video
   * @param {string} isImage - indica a que archivo del servidor apuntar true=imagenes false=videos
   * @param {string} name - nombre de imágen o video
   * @author Kenzo Sashida 
   * @version 1.0.0 - Julio 2024
   */
const deleteImage = async(name,isImage) =>{
    const url = `${baseUrl}/slider/delete-multimedia/${name}?slider=${isImage}`
    const token = await authHeader()
    const response = await axios.delete(url,{
        headers:token
    })
    return response.data
}

export default {
    getImages,
    uploadImage,
    updateImage,
    deleteImage
}